import {
  Box,
  Card,
  CardActionArea,
  Stack,
  Typography,
  alpha,
  styled,
} from "@mui/material"
import { Link } from "@pharmupp/p3-front-commons"
import type { PropsWithChildren } from "react"

type CancelledProps = {
  cancelled?: boolean
}

export const AGENDA_EVENT_HEIGHT = 51

const cardSx = {
  backgroundColor: "transparent",
  border: 0,
}
const containerSx = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "left",
  gap: 2,
}
export const CardContainer = ({
  link,
  children,
}: PropsWithChildren<{
  link?: string
}>) =>
  link ? (
    <Card component={Link} to={link} sx={cardSx}>
      <CardActionArea sx={containerSx}>{children}</CardActionArea>
    </Card>
  ) : (
    <Card sx={{ ...cardSx, ...containerSx }}>{children}</Card>
  )

export const DateSquare = styled(Stack)(({ theme }) => ({
  minWidth: "51px",
  height: "51px",
  borderRadius: "2px",
  border: `1px solid ${alpha(theme.palette.grey.ultraLight, 0.2)}`,
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  backgroundColor: alpha(theme.palette.grey.ultraLight, 0.15),
  fontWeight: 600,
}))

export const Day = styled(Typography, {
  shouldForwardProp: (props) => props !== "cancelled",
})<CancelledProps>(({ theme: { palette }, cancelled }) => ({
  color: cancelled ? palette.common.red : palette.success.main,
  fontWeight: "inherit",
}))
export const Month = styled(Typography)(({ theme: { palette, typography } }) => ({
  textTransform: "uppercase",
  color: palette.grey.light,
  fontSize: typography.pxToRem(12),
  fontWeight: "inherit",
}))

export const ContentContainer = styled(Stack)(({ theme }) => ({
  justifyContent: "space-evenly",
  gap: theme.spacing(0.5),
}))

export const AgendaEventTitle = styled(Typography, {
  shouldForwardProp: (props) => props !== "cancelled",
})<CancelledProps>(({ theme: { typography, palette }, cancelled }) => ({
  color: cancelled ? palette.grey.light : palette.common.darkBlue,
  fontSize: typography.pxToRem(14),
  fontWeight: 600,
  lineHeight: typography.pxToRem(16),
  overflow: "hidden",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  /* number of lines to show */
  WebkitLineClamp: "2",
  lineClamp: "2",
}))

export const TimesContainer = styled(Box, {
  shouldForwardProp: (props) => props !== "cancelled",
})<CancelledProps>(({ theme: { typography, palette }, cancelled }) => ({
  fontSize: typography.pxToRem(12),
  lineHeight: typography.pxToRem(14),
  color: cancelled ? palette.common.red : palette.common.darkBlue,
}))

export const TypoSpan = styled("span")({
  fontSize: "inherit",
  lineHeight: "inherit",
})

export const Times = styled(TypoSpan, {
  shouldForwardProp: (props) => props !== "cancelled",
})<CancelledProps>(({ cancelled }) => ({
  textDecoration: cancelled ? "line-through" : "unset",
}))

export const NoAgendaEvent = styled(Card)(({ theme: { spacing, palette } }) => ({
  display: "flex",
  alignItems: "center",
  paddingInline: spacing(2),
  paddingBlock: spacing(1),
  color: palette.grey.light,
  minHeight: AGENDA_EVENT_HEIGHT,
}))
